import { useEffect, useState, useRef } from 'react';

const InvitationComponent = () => {
  const [htmlContent, setHtmlContent] = useState('');
  const scriptRefs = useRef([]);

  useEffect(() => {
    const fetchInvitation = async () => {
      const referrer = document.referrer || '';
      if (
        referrer.includes('immortality.lt') ||
        referrer.includes('immortality.global')
      ) {
        return;
      }

      try {
        const host =
          process.env.NODE_ENV === 'development'
            ? 'immortality.lt'
            : 'immortality.global';
        const locale = navigator.language.split('-')[0] || 'en';
        const response = await fetch(
          `https://${host}/invitation.php?lang=${locale}&delay=5000`,
          {
            method: 'GET',
            headers: {
              'Content-Type': 'text/html',
            },
          }
        );

        if (!response.ok) {
          throw new Error('Failed to fetch invitation');
        }

        const html = await response.text();

        // Create a temporary container to parse HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Extract scripts
        const scripts = doc.querySelectorAll('script');
        const styles = doc.querySelectorAll('style');
        const nonScriptHtml = doc.body.innerHTML;

        // Set HTML content (without scripts to avoid duplication)
        setHtmlContent(nonScriptHtml);

        // Clean up previous scripts
        scriptRefs.current.forEach((script) => {
          if (script.parentNode) {
            script.parentNode.removeChild(script);
          }
        });
        scriptRefs.current = [];

        // Process scripts
        scripts.forEach((script) => {
          const newScript = document.createElement('script');
          if (script.src) {
            // External script
            newScript.src = script.src;
            newScript.async = true;
          } else {
            // Inline script
            newScript.textContent = script.textContent;
          }
          document.body.appendChild(newScript);
          scriptRefs.current.push(newScript);
        });

        // Process styles
        styles.forEach((style) => {
          const newStyle = document.createElement('style');
          newStyle.textContent = style.textContent;
          document.head.appendChild(newStyle);
          scriptRefs.current.push(newStyle);
        });
      } catch (error) {
        console.error('Error fetching invitation:', error);
      }
    };

    fetchInvitation();

    // Cleanup scripts on unmount
    return () => {
      scriptRefs.current.forEach((script) => {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      scriptRefs.current = [];
    };
  }, []);

  return (
    <div
      className="invitation-content"
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  );
};

export default InvitationComponent;